import Vue from 'vue';
import Router from 'vue-router'
import Home from './views/Home.vue'
import store from './store'

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      alias: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/project',
      name: 'list',
      component: () => import(/* webpackChunkName: "project" */ './views/Project.vue')
    },
    {
      path: '/project/:id',
      name: 'project',
      component: () => import(/* webpackChunkName: "projectDetail" */ './views/ProjectDetail.vue')
    },
    {
      path: '/resume',
      name: 'resume',
      component: () => import(/* webpackChunkName: "resume" */ './views/Resume.vue')
    },
    {
      path: '/oops',
      name: 'error',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "error" */ './views/Error.vue')
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    // scroll to page top if using in-page routing;
    // keep scroll position if using browser back/forward buttons
    return savedPosition ? savedPosition : { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  // 404
  if (!to.matched.length) {
    console.warn('[Route Guard] Not found:', to);
    next({ name: 'error' });
  }
  next();
});

router.afterEach((to) => {
  store.dispatch('showWhiteNav', !(to.name === 'home'));
});

export default router;
